import {createStrokeSVG} from './TEMPLATE'

// tabler: x
export const TimesLarge_Stroke2_Corner0_Rounded = createStrokeSVG({
  paths: ['M18 6l-12 12', 'M6 6l12 12'],
  viewBox: '2 2 20 20',
  strokeWidth: 2,
})
